import React, { useCallback } from 'react';
import { Checkbox, Typography } from '@mui/material';
import Tabela from 'components/Tabela Grid';
import _ from 'lodash';

export default function TabelaLaudosAutomatizador({
    laudos,
    laudosSelecionados,
    setLaudosSelecionados
}) {

    const handleSelectAll = (event) => {
        if (event.target.checked) {
            setLaudosSelecionados([...laudos]);
        } else {
            setLaudosSelecionados([]);
        }
    };

    const handleSelectOne = (laudo) => {
        const isSelected = laudosSelecionados.some(l => l.uid === laudo.uid);

        if (isSelected) {
            setLaudosSelecionados(laudosSelecionados.filter(l => l.uid !== laudo.uid));
        } else {
            setLaudosSelecionados([...laudosSelecionados, laudo]);
        }
    };

    const isSelected = (laudo) => {
        return laudosSelecionados.some(l => l.uid === laudo.uid);
    };

    const isAllSelected = laudos.length > 0 && laudosSelecionados.length === laudos.length;
    const isIndeterminate = laudosSelecionados.length > 0 && laudosSelecionados.length < laudos.length;

    const getValueSort = (linha, coluna) => {
        if (coluna.field === "COL_SELECT") {
            return "";
        }

        let value = _.get(linha, coluna.field);

        if (value && value.toDate) {
            value = value.toDate().toISOString();
        } else if (value && typeof value === 'object') {
            value = JSON.stringify(value);
        }

        return value || "";
    };

    const colunasDefault = [
        {
            field: "COL_SELECT",
            label: (
                <Checkbox
                    checked={isAllSelected}
                    indeterminate={isIndeterminate}
                    onChange={handleSelectAll}
                />
            ),
            sizecol: "80"
        },
        { field: "sequencialIndex", label: "Visita Nº", sizecol: "80" },
        { field: "data", label: "Data da Visita", sizecol: "135" },
        { field: "cliente.nome", label: "Cliente" },
        { field: "fazenda.nomeFazenda", label: "Fazenda" },
        { field: "status", label: "Status Atual", sizecol: "120" },
        { field: "tecnico.nome", label: "Técnico", sizecol: "150" },
    ];

    const handleRowClick = (item) => {
        if (window.event?.ctrlKey || window.event?.metaKey) {
            // ctrl or cmd key is pressed, open in new tab
            const url = `#/visita?uid=${item.uid}`;
            window.open(url, '_blank');
        } else {
            console.log("onRowClick", item)
        }
    };

    const RenderCell = useCallback((props) => {
        const { coluna, linha } = props;

        if (coluna.field === "COL_SELECT") {
            return (
                <Checkbox
                    checked={isSelected(linha)}
                    onChange={() => handleSelectOne(linha)}
                />
            );
        }

        let value = _.get(linha, coluna.field);

        if (!value) {
            value = "";
        }

        if (value.toDate) {
            try {
                let dateV = value.toDate();
                var dia = dateV.getDate().toString();
                var diaF = dia.length === 1 ? "0" + dia : dia;
                var mes = (dateV.getMonth() + 1).toString();
                var mesF = mes.length === 1 ? "0" + mes : mes;
                var anoF = dateV.getFullYear();
                value = diaF + "/" + mesF + "/" + anoF;
            } catch (error) {
                value = "";
            }
        }

        return <Typography component="div">{value || ""}</Typography>;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [laudosSelecionados]);

    return (
        <div style={{ flex: 1 }}>
            <Tabela
                sortColuns={true}
                onRowClick={handleRowClick}
                getValueSort={getValueSort}
                data={laudos || []}
                columns={colunasDefault}
                msgSemRegistro={"Nenhum laudo encontrado"}
                rowsPer={15}
                RenderCell={RenderCell}
            />
        </div>
    );
}